const GA_ID = "G-H6SJCZSZEB";
const DEBUG = false; // turn off in production

// Initialize GA once on first load
export const onClientEntry = () => {
  if (!GA_ID) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());

  window.gtag("config", GA_ID, {
    send_page_view: false, // we handle manually
    debug_mode: DEBUG,
  });
};

// Track SPA route changes
export const onRouteUpdate = ({ location }) => {
  if (typeof window.gtag !== "function") return;

  window.gtag("event", "page_view", {
    page_path: location.pathname + location.search,
    debug_mode: DEBUG,
  });
};
